import CartDrawer from './common/cartDrawer';
import Footer from './common/footer';
import Header from './common/header';
import MenuMobile from './common/menuMobile';
import Popup from './components/popup';
import Webforms from './common/webforms';
import ProductPurchase from './components/productPurchase';
import { NewsletterComponent, PriceComponent } from './components/vndaComponents.js';
import { setSearch } from './components/utilities';
import setQuotationSwiper from './pages/home/quotation.js';

let threshold = 700;
if (window.innerWidth < 768) threshold = 400;

window.lazyLoadOptions = {
  elements_selector: '.lazy',
  threshold,
};

window.addEventListener(
  'LazyLoad::Initialized',
  (event) => {
    window.lazyLoadInstance = event.detail.instance;
  },
  { passive: true }
);

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cVnda - Tecnologia em Ecommerce',
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  // Header.init();
  Footer.init();
  Popup.init();
  ProductPurchase.init();
  PriceComponent.init();
  Webforms.init();
  NewsletterComponent.init();
  setQuotationSwiper();
  setSearch();

  const larguraTela = window.innerWidth;

  if (larguraTela < 992) {
    MenuMobile.init();
  }

  //página de assinatura
  $('.assinatura-button').first().addClass('first');

  // copiar cupom

  var btnCopy = document.querySelector('#btnCopy');
  var btnSpaceCopy = document.querySelector('.copy');

  if (btnCopy) {
    btnCopy.addEventListener('click', function (event) {
      if (event.target.closest('#btnCopy')) {
        copyTextToClipboard(btnCopy.closest('.copy').textContent.trim());
      }
    });
  }

  function copyTextToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(function () {
        let svgCopy = document.querySelector('.top-bar .copiar .copy #btnCopy svg');
        btnCopy.innerHTML = 'Copiado!';
        setTimeout(() => {
          btnCopy.replaceChildren(svgCopy);
        }, 2000);
      })
      .catch(function (err) {
        console.error('Erro ao copiar texto: ', err);
      });
  }
});

// esconder AdOpts caso for aceito

function setCookie(nome, valor, dias) {
  var d = new Date();
  d.setTime(d.getTime() + dias * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = nome + '=' + valor + '; ' + expires + '; path=/; SameSite=Lax';
}

function getCookie(nome) {
  var nameEQ = nome + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function aplicarEventosAdopt() {
  var botaoAceitar = document.getElementById('adopt-accept-all-button');
  var botaoRejeitar = document.getElementById('adopt-reject-all-button');

  if (botaoAceitar && botaoRejeitar) {
    botaoAceitar.addEventListener('click', function () {
      setCookie('consentimento', 'aceito', 30);
      esconderBotaoAdopt();
    });

    botaoRejeitar.addEventListener('click', function () {
      setCookie('consentimento', 'recusado', 30);
      // Mantém o botão visível ao recusar
    });
  }
}

function esconderBotaoAdopt() {
  var btn = document.getElementById('adopt-controller-button');
  if (btn) {
    btn.classList.add('hide');
  }
}

// Verifica consentimento ao carregar a página
window.addEventListener('load', function () {
  setTimeout(aplicarEventosAdopt, 500);

  // Evento ao abrir o popup
  var botaoController = document.querySelector('#adopt-controller-button');
  if (botaoController) {
    botaoController.addEventListener('click', function () {
      setTimeout(aplicarEventosAdopt, 500);
    });
  }
  var consentimento = getCookie('consentimento');
  if (consentimento === 'aceito') {
    setTimeout(esconderBotaoAdopt, 200);
  }
});
